/** AP10 copy (one group per control; a ticket edits only its own file). */
export const ap10PtBr = {
  title: 'Cartões, reembolsos e custos de contratos',
  description: 'Gastos de cartão, reembolsos e custos de contratos reconhecidos no período.',
  prerequisite: 'Requer cobertura de cartões e custos de contratos.',
  diagnosticLabel: 'Reembolsos capturados sem suporte',
  detail: {
    openRequest: 'Abrir reembolso',
    supportNote:
      'Um anexo sozinho não comprova o reconhecimento correto: esta revisão só aponta o que falta.',
    restricted:
      'Reembolsos de funcionários e colaboradores são confidenciais: seus detalhes e valores não aparecem para você.',
    truncated:
      'Mostrando {{shown}} de {{count}} reembolsos. Os totais por grupo só aparecem quando a lista cabe inteira.',
  },
  reasons: {
    MISSING_RECEIPT: {
      title: 'Reembolsos sem comprovante',
      item: 'reembolso capturado sem comprovante',
    },
    MISSING_CLASSIFICATION: {
      title: 'Reembolsos sem classificação',
      item: 'reembolso com comprovante e sem classificação na conta',
    },
    other: {
      title: 'Outros reembolsos sem suporte',
      item: 'reembolso sem suporte',
    },
  },
};

export const ap10En: typeof ap10PtBr = {
  title: 'Cards, reimbursements and contract costs',
  description: 'Card spend, reimbursements and contract costs recognized in the period.',
  prerequisite: 'Needs card and contract cost coverage.',
  diagnosticLabel: 'Captured reimbursements missing support',
  detail: {
    openRequest: 'Open reimbursement',
    supportNote:
      'An attachment alone does not prove correct recognition: this review only points out what is missing.',
    restricted:
      'Employee and collaborator reimbursements are confidential: their details and amounts are not shown to you.',
    truncated:
      'Showing {{shown}} of {{count}} reimbursements. Totals per group only appear when the whole list fits.',
  },
  reasons: {
    MISSING_RECEIPT: {
      title: 'Reimbursements without a receipt',
      item: 'captured reimbursement without a receipt',
    },
    MISSING_CLASSIFICATION: {
      title: 'Reimbursements without a classification',
      item: 'reimbursement with a receipt and no account classification',
    },
    other: {
      title: 'Other reimbursements missing support',
      item: 'reimbursement missing support',
    },
  },
};
